import React, { useState } from 'react';
import { Instagram as InstagramIcon, Facebook as FacebookIcon, Linkedin as LinkedinIcon, Mail as MailIcon, Phone as PhoneIcon, MapPin as MapPinIcon, MessageCircle as MessageCircleIcon, CalendarDays as CalendarDaysIcon, ChevronRight as ChevronRightIcon } from 'lucide-react';
function TikTokIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor" data-id="element-92">
      <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.34-6.34V8.73a8.19 8.19 0 004.76 1.52V6.79a4.83 4.83 0 01-1-.1z" data-id="element-93" />
    </svg>;
}
export function FooterSection() {
  const currentYear = new Date().getFullYear();
  const [miniForm, setMiniForm] = useState({
    name: '',
    email: '',
    phone: '',
    company: ''
  });
  const services = ['Meta Ads · Google Ads · TikTok Ads · YouTube Ads', 'Email · SMS · Retargeting Automatizado', 'Automatización con IA para Ventas 24/7', 'Funnels Quirúrgicos por Industria', 'Blindaje Digital & Anti-Ban', 'PR Digital & Posicionamiento en Medios', 'CRM & Data Tracking Avanzado', 'Video Marketing IA · SEO · Branding', 'Gestión de Reputación · Google Maps', 'Diseño Web · Landing Pages · CRO'];
  const recursos = [{
    label: 'Blog de Estrategia',
    href: '#'
  }, {
    label: 'Casos de Éxito',
    href: '#'
  }, {
    label: 'Política de Privacidad',
    href: '#'
  }, {
    label: 'Términos y Condiciones',
    href: '#'
  }];
  const socials = [{
    icon: <InstagramIcon className="w-5 h-5" data-id="element-94" />,
    href: 'https://www.instagram.com/doctorecommerce',
    label: 'Instagram'
  }, {
    icon: <FacebookIcon className="w-5 h-5" data-id="element-95" />,
    href: 'https://www.facebook.com/doctorecommerce',
    label: 'Facebook'
  }, {
    icon: <LinkedinIcon className="w-5 h-5" data-id="element-96" />,
    href: 'https://www.linkedin.com/company/doctorecommerce',
    label: 'LinkedIn'
  }, {
    icon: <TikTokIcon className="w-5 h-5" data-id="element-97" />,
    href: 'https://www.tiktok.com/@doctorecommerce',
    label: 'TikTok'
  }];
  return <footer className="bg-[#0a0a0a] border-t border-carbon-lighter" data-id="element-98">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20" data-id="element-99">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-8" data-id="element-100">
          {/* Brand Column */}
          <div className="lg:col-span-3" data-id="element-101">
            <div className="mb-6" data-id="element-102">
              <div className="w-14 h-14 bg-carbon-light border border-carbon-lighter rounded-md flex items-center justify-center mb-5" data-id="element-103">
                <span className="text-gold font-black text-xs leading-tight text-center" data-id="element-104">
                  DOCTOR
                  <br data-id="element-105" />
                  ECOMMERCE
                </span>
              </div>
            </div>
            <h3 className="text-gold font-semibold text-lg italic mb-5 leading-snug" data-id="element-106">
              La cura para negocios estancados.
            </h3>
            <p className="text-gray-500 text-sm leading-relaxed mb-8" data-id="element-107">
              En Doctor Ecommerce no gestionamos redes, operamos sistemas de
              adquisición de alto rendimiento. Con sede estratégica en Tampa,
              Florida, servimos a dueños de negocios en todo Estados Unidos,
              transformando presupuestos publicitarios en máquinas de generación
              de llamadas y ventas diarias.
            </p>
            {/* Social Icons */}
            <div className="flex items-center gap-4" data-id="element-108">
              {socials.map(s => <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gold transition-colors" aria-label={s.label} data-id="element-109">
                  {s.icon}
                </a>)}
            </div>
          </div>

          {/* Servicios Column */}
          <div className="lg:col-span-3" data-id="element-110">
            <h4 className="text-gold font-bold text-sm uppercase tracking-wider mb-6" data-id="element-111">
              Servicios
            </h4>
            <ul className="space-y-3" data-id="element-112">
              {services.map((service, i) => <li key={i} className="text-gray-500 text-sm leading-relaxed" data-id="element-113">
                  {service}
                </li>)}
            </ul>
          </div>

          {/* Recursos Column */}
          <div className="lg:col-span-2" data-id="element-114">
            <h4 className="text-gold font-bold text-sm uppercase tracking-wider mb-6" data-id="element-115">
              Recursos
            </h4>
            <ul className="space-y-3" data-id="element-116">
              {recursos.map(r => <li key={r.label} data-id="element-117">
                  <a href={r.href} className="text-gray-500 hover:text-white text-sm transition-colors flex items-center gap-1.5" data-id="element-118">
                    <ChevronRightIcon className="w-3 h-3 text-gold/60" data-id="element-119" />
                    {r.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contacto Directo Column */}
          <div className="lg:col-span-4" data-id="element-120">
            <h4 className="text-gold font-bold text-sm uppercase tracking-wider mb-6" data-id="element-121">
              Contacto Directo
            </h4>
            <ul className="space-y-4 mb-8" data-id="element-122">
              <li data-id="element-123">
                <span className="flex items-start gap-3 text-gray-400 text-sm" data-id="element-124">
                  <MapPinIcon className="w-4 h-4 shrink-0 mt-0.5 text-gold/60" data-id="element-125" />
                  1001 WATER ST, TAMPA FL 33602
                </span>
              </li>
              <li data-id="element-126">
                <a href="tel:+18133848460" className="flex items-center gap-3 text-gray-400 hover:text-white text-sm transition-colors" data-id="element-127">
                  <PhoneIcon className="w-4 h-4 shrink-0 text-gold/60" data-id="element-128" />
                  813-384-8460
                </a>
              </li>
              <li data-id="element-129">
                <a href="mailto:doctor.ecommerceus@gmail.com" className="flex items-center gap-3 text-gray-400 hover:text-white text-sm transition-colors" data-id="element-130">
                  <MailIcon className="w-4 h-4 shrink-0 text-gold/60" data-id="element-131" />
                  doctor.ecommerceus@gmail.com
                </a>
              </li>
            </ul>

            {/* CTA Buttons */}
            <div className="flex flex-col gap-3" data-id="element-132">
              <a href="https://wa.me/18133848460" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 px-6 py-3 bg-emerald hover:bg-emerald/90 text-white font-bold text-sm rounded-full transition-all" data-id="element-133">
                <MessageCircleIcon className="w-4 h-4" data-id="element-134" />
                Habla con un Especialista
              </a>
              <a href="https://calendar.app.google/gDsqAVqmwUYmaZHe9" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 px-6 py-3 bg-transparent border-2 border-gold/40 text-white font-bold text-sm rounded-full hover:border-gold hover:bg-gold/5 transition-all" data-id="element-135">
                <CalendarDaysIcon className="w-4 h-4" data-id="element-136" />
                RESERVAR DIAGNÓSTICO
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="border-t border-carbon-lighter" data-id="element-137">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-id="element-138">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16" data-id="element-139">
            {/* Partners */}
            <div data-id="element-140">
              <h5 className="text-gray-500 text-xs font-semibold uppercase tracking-widest mb-5" data-id="element-141">
                Partners Certificados y Tecnología de Élite
              </h5>
              <div className="flex items-center gap-3 flex-wrap" data-id="element-142">
                {['Meta', 'Google Ads', 'HubSpot', 'Certified', 'Shopify'].map(partner => <div key={partner} className="h-12 px-4 bg-carbon-light border border-carbon-lighter rounded-md flex items-center justify-center" data-id="element-143">
                      <span className="text-gray-600 text-xs font-semibold" data-id="element-144">
                        {partner}
                      </span>
                    </div>)}
              </div>
            </div>

            {/* Mini Contact Form */}
            <div data-id="element-145">
              <h5 className="text-gray-500 text-xs font-semibold uppercase tracking-widest mb-5" data-id="element-146">
                ¿Quieres que te contactemos?
              </h5>
              <form onSubmit={e => {
              e.preventDefault();
              document.getElementById('contact-form')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} className="flex flex-wrap gap-3" data-id="element-147">
                <input type="text" placeholder="Tu Nombre" value={miniForm.name} onChange={e => setMiniForm({
                ...miniForm,
                name: e.target.value
              })} className="flex-1 min-w-[140px] bg-carbon-light border border-carbon-lighter rounded-md px-4 py-3 text-white text-sm placeholder:text-gray-600 focus:outline-none focus:border-gold/50 transition-colors" data-id="element-148" />
                <input type="email" placeholder="Tu Email" value={miniForm.email} onChange={e => setMiniForm({
                ...miniForm,
                email: e.target.value
              })} className="flex-1 min-w-[140px] bg-carbon-light border border-carbon-lighter rounded-md px-4 py-3 text-white text-sm placeholder:text-gray-600 focus:outline-none focus:border-gold/50 transition-colors" data-id="element-149" />
                <input type="tel" placeholder="Tu Teléfono" value={miniForm.phone} onChange={e => setMiniForm({
                ...miniForm,
                phone: e.target.value
              })} className="flex-1 min-w-[140px] bg-carbon-light border border-carbon-lighter rounded-md px-4 py-3 text-white text-sm placeholder:text-gray-600 focus:outline-none focus:border-gold/50 transition-colors" data-id="element-150" />
                <input type="text" placeholder="Nombre de tu Empresa" value={miniForm.company} onChange={e => setMiniForm({
                ...miniForm,
                company: e.target.value
              })} className="flex-1 min-w-[140px] bg-carbon-light border border-carbon-lighter rounded-md px-4 py-3 text-white text-sm placeholder:text-gray-600 focus:outline-none focus:border-gold/50 transition-colors" data-id="element-151" />
                <button type="submit" className="px-8 py-3 bg-gold hover:bg-gold-light text-carbon font-bold text-sm rounded-md transition-all" data-id="element-152">
                  ENVIAR
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright & Disclaimer */}
      <div className="border-t border-carbon-lighter/50" data-id="element-153">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-154">
          <p className="text-gray-600 text-xs text-center mb-3" data-id="element-155">
            © {currentYear} Doctor Ecommerce. Todos los derechos reservados.
          </p>
          <p className="text-gray-700 text-[11px] leading-relaxed text-center" data-id="element-156">
            This site is not a part of the Facebook™ website or Facebook™ Inc.
            Additionally, this site is NOT endorsed by Facebook™ in any way.
            FACEBOOK™ is a trademark of FACEBOOK™, Inc. Disclaimer: Results
            may vary and are not guaranteed. The results shown are not typical
            and your results will vary based on your effort, experience, and
            other factors.
          </p>
        </div>
      </div>
    </footer>;
}